export default __webpack_public_path__ + "static/media/slider3-6.9d736520.jpg";